import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { getServerConfig } from '@app/origami-api/server-config';
import { AuthenticateService } from '@app/origami-api/services/authenticate/authenticate.service';
import { LocalStorageKeys, LocalStorageService } from '@app/services/local-storage.service';
import { validateReturnUrl } from '@app/shared/utils/url-validation';

@Injectable({
  providedIn: 'root',
})
export class GoToLoginService {
  constructor(
    private readonly router: Router,
    private readonly authenticateService: AuthenticateService,
    private readonly route: ActivatedRoute,
    private readonly localStorageService: LocalStorageService,
  ) {}

  goToLogin(options?: { logOff?: boolean }) {
    if (options && options.logOff) {
      this.localStorageService.setItem(LocalStorageKeys.ti_session_expired, 0);
      this.authenticateService.logoff().subscribe((res) => {
        options.logOff = false;
        this.goToLogin(options);
      });
      return;
    }

    const isCAS =
      /*window.location.href.indexOf('localhost') === -1 &&*/ getServerConfig().serverCfg.centralAuthentication ===
      'cas';
    if (isCAS) {
      const returnUrl = this.route.snapshot.queryParams['returnUrl'] || this.route.snapshot.queryParams['ReturnUrl'];

      const validatedUrl = returnUrl ? validateReturnUrl(returnUrl) : null;
      if (validatedUrl) {
        window.location.href = validatedUrl;
      } else {
        // Invalid or missing returnUrl - redirect to login page without returnUrl to prevent infinite loop
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete('returnUrl');
        currentUrl.searchParams.delete('ReturnUrl');
        window.location.href = currentUrl.toString();
      }
    } else {
      this.router.navigate(['/auth/login']);
    }
  }
}
